"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeContext = void 0;
var react_1 = __importStar(require("react"));
var config_1 = __importDefault(require("../../config"));
var setTheme_1 = __importDefault(require("../../shared/utilities/setTheme"));
var defaultDispatchTheme = function (val) { return val; };
var defaultThemeState = {
    theme: config_1.default.defaults.theme,
    setTheme: defaultDispatchTheme
};
exports.ThemeContext = react_1.default.createContext(defaultThemeState);
// Theme context provider
function ThemeProvider(props) {
    var _a = (0, react_1.useState)(function () { return props.initialTheme || config_1.default.defaults.theme; }), theme = _a[0], setTheme = _a[1];
    (0, react_1.useEffect)(function () {
        if (process.env.NODE_ENV === "production") {
            (0, setTheme_1.default)(document, theme, "/static/themes/");
        }
        else {
            (0, setTheme_1.default)(document, theme);
        }
    }, [theme]);
    var value = (0, react_1.useMemo)(function () { return ({
        theme: theme,
        setTheme: setTheme
    }); }, [theme, setTheme]);
    return react_1.default.createElement(exports.ThemeContext.Provider, { value: value }, props.children);
}
exports.default = ThemeProvider;
